

import productsJson from '../../json/products.json'

export default {
  /***** ITEMS is all products***/
  items: productsJson,
  /*****FEATURED ITEMS***/
  featuredItems: [
    {
      sku: 1,
      cat: 5,
      catName: 'Pizza',
      tags: 'beverages',
      title: 'Pizzas',
      ratings: 5,
      review: 2,
      prevPrice: '20.00',
      price: '18.00',
      excerpt: 'Gourmet burger with arugula, feta cheese, quail eggs and...',
      description: 'Cursus mal suada faci lisis. Lorem ipsum dolor.ipsum dolor sit amet, cons ectetur elit. Ves tibulum nec odios Suspe ndisse cursus mal suada faci lisis. Lorem ipsum dolor.ipsum dolor sit amet,.Lorem ipsum dolor.',
      crust: [
        {name: 'Double Crust', value: 'double_crust'},
        {name: 'Single Crust', value: 'single_crust'},
        {name: 'Thick Crust', value: 'thick_crust'},
        {name: 'Thin Crust', value: 'thin_crust'}
      ],
      size: [
        {name: 'Large', value: 'large'},
        {name: 'Medium', value: 'medium'},
        {name: 'Small', value: 'small'}
      ],
      img: 'promo_order_1.jpg'
    },
    {
      sku: 2,
      cat: 5,
      catName: 'Pizza',
      tags: 'beverages',
      title: 'Botanas',
      ratings: 4,
      review: 2,
      prevPrice: '20.00',
      price: '18.00',
      excerpt: 'Gourmet burger with arugula, feta cheese, quail eggs and...',
      description: 'Cursus mal suada faci lisis. Lorem ipsum dolor.ipsum dolor sit amet, cons ectetur elit. Ves tibulum nec odios Suspe ndisse cursus mal suada faci lisis. Lorem ipsum dolor.ipsum dolor sit amet,.Lorem ipsum dolor.',
      crust: [
        {name: 'Double Crust', value: 'double_crust'},
        {name: 'Single Crust', value: 'single_crust'},
        {name: 'Thick Crust', value: 'thick_crust'},
        {name: 'Thin Crust', value: 'thin_crust'}
      ],
      size: [
        {name: 'Large', value: 'large'},
        {name: 'Medium', value: 'medium'},
        {name: 'Small', value: 'small'}
      ],
      img: 'promo_order_4.png'
    }
  ],
  /*****FEATURED ITEMS***/
  popularItems: [
    {
      sku: 1,
      cat: 5,
      catName: 'Pizza',
      tags: 'beverages',
      title: 'Mexican Green Wave',
      ratings: 4,
      review: 2,
      prevPrice: '20.00',
      price: '18.00',
      excerpt: 'Gourmet burger with arugula, feta cheese, quail eggs and...',
      description: 'Cursus mal suada faci lisis. Lorem ipsum dolor.ipsum dolor sit amet, cons ectetur elit. Ves tibulum nec odios Suspe ndisse cursus mal suada faci lisis. Lorem ipsum dolor.ipsum dolor sit amet,.Lorem ipsum dolor.',
      crust: [
        {name: 'Double Crust', value: 'double_crust'},
        {name: 'Single Crust', value: 'single_crust'},
        {name: 'Thick Crust', value: 'thick_crust'},
        {name: 'Thin Crust', value: 'thin_crust'}
      ],
      size: [
        {name: 'Large', value: 'large'},
        {name: 'Medium', value: 'medium'},
        {name: 'Small', value: 'small'}
      ],
      img: 'p-6.png'
    },
    {
      sku: 2,
      cat: 5,
      catName: 'Pizza',
      tags: 'beverages',
      title: 'Double Cheese Pizza',
      ratings: 4,
      review: 2,
      prevPrice: '20.00',
      price: '18.00',
      excerpt: 'Gourmet burger with arugula, feta cheese, quail eggs and...',
      description: 'Cursus mal suada faci lisis. Lorem ipsum dolor.ipsum dolor sit amet, cons ectetur elit. Ves tibulum nec odios Suspe ndisse cursus mal suada faci lisis. Lorem ipsum dolor.ipsum dolor sit amet,.Lorem ipsum dolor.',
      crust: [
        {name: 'Double Crust', value: 'double_crust'},
        {name: 'Single Crust', value: 'single_crust'},
        {name: 'Thick Crust', value: 'thick_crust'},
        {name: 'Thin Crust', value: 'thin_crust'}
      ],
      size: [
        {name: 'Large', value: 'large'},
        {name: 'Medium', value: 'medium'},
        {name: 'Small', value: 'small'}
      ],
      img: 'pizza_slide_4.png'
    },
    {
      sku: 3,
      cat: 5,
      catName: 'Pizza',
      tags: 'beverages',
      title: 'BBQ Pizza TinTin',
      ratings: 4,
      review: 2,
      prevPrice: '20.00',
      price: '20.00',
      excerpt: 'Gourmet burger with arugula, feta cheese, quail eggs and...',
      description: 'Cursus mal suada faci lisis. Lorem ipsum dolor.ipsum dolor sit amet, cons ectetur elit. Ves tibulum nec odios Suspe ndisse cursus mal suada faci lisis. Lorem ipsum dolor.ipsum dolor sit amet,.Lorem ipsum dolor.',
      crust: [
        {name: 'Double Crust', value: 'double_crust'},
        {name: 'Single Crust', value: 'single_crust'},
        {name: 'Thick Crust', value: 'thick_crust'},
        {name: 'Thin Crust', value: 'thin_crust'}
      ],
      size: [
        {name: 'Large', value: 'large'},
        {name: 'Medium', value: 'medium'},
        {name: 'Small', value: 'small'}
      ],
      img: 'pizza_slide_4.png'
    },
    {
      sku: 4,
      cat: 3,
      catName: 'Drinks',
      tags: 'beverages',
      title: 'Lemon Juice',
      ratings: 4,
      review: 2,
      prevPrice: '12.30',
      price: '20.00',
      excerpt: 'Gourmet burger with arugula, feta cheese, quail eggs and...',
      description: 'Cursus mal suada faci lisis. Lorem ipsum dolor.ipsum dolor sit amet, cons ectetur elit. Ves tibulum nec odios Suspe ndisse cursus mal suada faci lisis. Lorem ipsum dolor.ipsum dolor sit amet,.Lorem ipsum dolor.',
      crust: [],
      size: [],
      img: 'juice_1.png'
    }
  ],
  /***Product Category***/
  category: [
    {
      id: 1,
      name: 'Chicken'
    },
    {
      id: 2,
      name: 'Donuts'
    },
    {
      id: 3,
      name: 'Drinks'
    },
    {
      id: 4,
      name: 'Fries'
    },
    {
      id: 5,
      name: 'Pizza'
    },
    {
      id: 6,
      name: 'Sandwich'
    },
    {
      id: 7,
      name: 'Burger'
    },
    {
      id: 8,
      name: 'Uncategorized'
    }
  ],
}



// WEBPACK FOOTER //
// ./src/store/products/state.js